import * as React from 'react';
import {useTheme} from '../../shared/theme';
import View from './view';
import {Route} from '@react-navigation/native';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {getStatePrograms} from '../../redux/actions/socialSupport/statePrograms';
import {stateProgramSelector} from '../../redux/selectors/socialSupport/statePrograms';
import {StateProgram} from '../../shared/models/socialSupport/stateProgram';
import {SocialSupportListData} from '../../shared/components/socialSupportList/model';

const stateProgramsToSocialSupportListData = (data: StateProgram[]): SocialSupportListData[] => {
  return data.map((program) => ({
    title: program.programName,
    children: program.subprograms.map((subprogram) => ({
      title: subprogram.subprogramName,
      children: subprogram.events.map((event) => ({
        title: event.eventName,
        table: {
          columns: [
            {field: 'directionOfExpenses', title: 'Направление расходов'},
            {field: 'sourceOfFinancing', title: 'Источник финансирования'},
            {field: 'budgets', title: 'Плановый объем расходов (тыс. руб.)'},
            {field: 'indicators', title: 'Номера целевых показателей'},
          ],
          data: event.rows,
        },
      })),
    })),
  }));
};

export const StateProgramsScreen = ({route}: {route: Route<string>}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const statePrograms = useSelector(stateProgramSelector());
  const title = 'Государственные программы';

  useEffect(() => {
    if (!statePrograms) {
      dispatch(getStatePrograms());
    }
  }, [statePrograms]);

  const dataSource = stateProgramsToSocialSupportListData(statePrograms ?? []);

  return <View theme={theme} route={route} socialSupportData={dataSource} title={title} />;
};
